<template>
  <b-row>
    <b-col cols="12" lg="12">
      <b-card :header="`Módulos da ${company.fantasyName}`">
        <b-card-body>
          <h5>Módulos ativos</h5>
          <b-form-checkbox v-model="company.modules.complaint.enabled" switch
            >Gestão de Relatos</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.conformity.enabled" switch
            >Gestão de Conformidade</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.qas.enabled" switch
            >Gestão de Dúvidas e Sugestões</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.dsar.enabled" switch
            >Acesso do Titular dos Dados</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.ombudsman.enabled" switch
            >Ouvidoria</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.mentions.enabled" switch
            >Menções</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.courses.enabled" switch
            >Cursos</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.nr1.enabled" switch
            >Questionários NR-1 (Riscos Ocupacionais)</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.requirements.enabled" switch
            >GRC: Requisitos</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.risks.enabled" switch
            >GRC: Riscos</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.controls.enabled" switch
            >GRC: Controles</b-form-checkbox
          >
          <b-form-checkbox v-model="company.modules.actionPlans.enabled" switch
            >GRC: Planos de Ação</b-form-checkbox
          >
          <b-form-checkbox
            v-model="company.modules.giftshospitality.enabled"
            switch
            >Brindes e Hospitalidade</b-form-checkbox
          >
          <b-form-checkbox
            v-model="company.modules.natureAnalysis.enabled"
            switch
            disabled
            >Busca por Natureza IA (em desenvolvimento)</b-form-checkbox
          >
        </b-card-body>
      </b-card>
      <b-row>
        <b-col cols="12">
          <b-card no-header body-class="p-0">
            <template #header>
              <div>
                <span
                  >Configurações do módulo
                  <strong>Gestão de Relatos</strong></span
                >
                <b-button
                  v-b-toggle.complaintConfig
                  size="sm"
                  variant="link"
                  class="pt-0 pb-0 float-right"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="complaintConfig" class="m-0">
              <b-card-body>
                <b-form-checkbox
                  v-model="company.modules.complaint.alternateForm"
                  switch
                  >Usa formulário alternativo
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="
                    company.modules.complaint.monitoringResponseEnabledByDefault
                  "
                  switch
                  >Resposta do denunciante habilitada desde o momento de envio
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="company.modules.complaint.enforceIdentification"
                  switch
                  >Identificação obrigatória
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="company.modules.complaint.aiSummaryEnabled"
                  switch
                  >Resumo Anonimizado com IA
                </b-form-checkbox>
                <br />
                <b-row>
                  <b-col cols="2">
                    <b-form-group label="Número sequencial">
                      <b-form-input
                        v-model="
                          company.modules.complaint.sequenceStartingNumber
                        "
                        type="number"
                        min="1"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card no-header body-class="p-0">
            <template #header>
              <div>
                <span
                  >Configurações do módulo
                  <strong>Gestão de Conformidade</strong></span
                >
                <b-button
                  v-b-toggle.conformityConfig
                  size="sm"
                  variant="link"
                  class="pt-0 pb-0 float-right"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="conformityConfig" class="m-0">
              <b-card-body>
                <b-form-checkbox-group
                  v-model="company.modules.conformity.categories"
                  :options="availableCategories"
                  value-field="_id"
                  text-field="name"
                  stacked
                  switches
                >
                </b-form-checkbox-group>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card no-header body-class="p-0">
            <template #header>
              <div>
                <span>Configurações do módulo <strong>Ouvidoria</strong></span>
                <b-button
                  v-b-toggle.ombudsmanConfig
                  size="sm"
                  variant="link"
                  class="pt-0 pb-0 float-right"
                >
                  <i class="when-opened fas fa-chevron-up" aria-hidden="true" />
                  <i
                    class="when-closed fas fa-chevron-down"
                    aria-hidden="true"
                  />
                </b-button>
              </div>
            </template>
            <b-collapse id="ombudsmanConfig" class="m-0">
              <b-card-body>
                <b-row>
                  <b-col cols="2">
                    <b-form-group label="Número sequencial">
                      <b-form-input
                        v-model="
                          company.modules.ombudsman.sequenceStartingNumber
                        "
                        type="number"
                        min="1"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-button variant="primary" @click="save">Salvar</b-button>
            <b-button class="ml-2" @click="reloadCompany">Cancelar</b-button>
            <b-button class="ml-2" variant="info" @click="$router.go(-1)"
              >Voltar</b-button
            >
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { getCompany, updateModules } from "../../api/company";
import { getRequirementCategories } from "../../api/requirements";

export default {
  name: "ModulesView",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      availableCategories: [],
      company: {
        modules: {
          complaint: {},
          conformity: {},
          qas: {},
          dsar: {},
          ombudsman: {},
          mentions: {},
          courses: {},
          nr1: {},
          requirements: {},
          risks: {},
          controls: {},
          actionPlans: {},
          giftshospitality: {},
        },
      },
    };
  },
  async created() {
    await this.reloadCompany();
    const response = await getRequirementCategories();
    this.availableCategories = response.data;
  },
  methods: {
    async reloadCompany() {
      const response = await getCompany(this.id);
      const company = response.data;
      company.modules = company.modules || {};
      company.modules.complaint = company.modules.complaint || {};
      company.modules.conformity = company.modules.conformity || {};
      company.modules.qas = company.modules.qas || {};
      company.modules.dsar = company.modules.dsar || {};
      company.modules.ombudsman = company.modules.ombudsman || {};
      company.modules.ombudsman.sequenceStartingNumber =
        company.modules.ombudsman.sequenceStartingNumber || 1;
      company.modules.mentions = company.modules.mentions || {};
      company.modules.courses = company.modules.courses || {};
      company.modules.nr1 = company.modules.nr1 || {};
      company.modules.requirements = company.modules.requirements || {};
      company.modules.risks = company.modules.risks || {};
      company.modules.controls = company.modules.controls || {};
      company.modules.actionPlans = company.modules.actionPlans || {};
      company.modules.giftshospitality = company.modules.giftshospitality || {};
      company.modules.natureAnalysis = company.modules.natureAnalysis || {};
      this.company = company;
    },
    async save() {
      try {
        await updateModules(this.company, this.company.modules);
        this.$bvToast.toast("Módulos editados com sucesso!", {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        });
      } catch (error) {
        if (error.response.status === 403) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
      }
    },
  },
};
</script>

<style>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
